import React, { useMemo } from 'react';
import { Form, FormInstance, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import ActionTypes from '@utils/deviceActions';
import {
  DeviceActionProps,
  DeviceActionStepsProps,
} from '@components/Actions/ActionsModal/types';
import rolesConstants from '@utils/rolesConstants';
import { ICustomer } from '@pages/Access/types';

interface FinancialLockUnlockPayloadProps {
  action: ActionTypes.FINANCIAL_LOCK | ActionTypes.FINANCIAL_UNLOCK;
  customerIds: number[];
}

interface FinancialLockUnlockProps {
  customerIds: ICustomer['id'][];
  isUpload?: boolean;
  form: FormInstance<any>;
}

const useFinancialLockUnlock = ({
  customerIds,
  isUpload,
  form,
}: FinancialLockUnlockProps): DeviceActionProps => {
  const { t } = useTranslation(['actions-modal', 'device-actions']);
  const financialType = Form.useWatch('financialType', form);

  const steps: DeviceActionStepsProps[] = useMemo(
    () => [
      {
        title: t('block-unlock.action'),
        name: 'financialType',
        showWhenUpload: true,
        content: (
          <Radio.Group optionType="button" disabled={isUpload && !customerIds}>
            <Radio value={ActionTypes.FINANCIAL_LOCK}>
              {t('block-unlock.block')}
            </Radio>
            <Radio value={ActionTypes.FINANCIAL_UNLOCK}>
              {t('block-unlock.unlock')}
            </Radio>
          </Radio.Group>
        ),
      },
    ],
    [customerIds, isUpload, t],
  );

  const payloadToSend = useMemo(
    (): FinancialLockUnlockPayloadProps => ({
      action: financialType ?? ActionTypes.FINANCIAL_LOCK,
      customerIds: customerIds ?? [],
    }),
    [customerIds, financialType],
  );

  return {
    title: t(
      `device-actions:labels.mot.${rolesConstants.FINANCIAL_LOCK_UNLOCK}`,
    ),
    steps,
    payloadToSend,
  };
};

export default useFinancialLockUnlock;
